import * as view from "../actions/view.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        // Bootstrap devicetype: xs, sm, md, lg
        deviceType: "",
        innerHeight: 0,
        innerWidth: 0,
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case view.SET_DEVICE_TYPE:
        return state.merge({
            deviceType: action.deviceType
        });
    case view.SET_INNER_HEIGHT:
        return state.merge({
            innerHeight: action.innerHeight
        });
    case view.SET_INNER_WIDTH:
        return state.merge({
            innerWidth: action.innerWidth
        });
    default:
        return state;
    }
}